var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBalancingSkipProductionFactor } from "../../balancingSelectors/selectBalancingConstants";
import { selectRecipeShouldShowInputIcon } from "../../balancingSelectors/selectBalancingUiDefinitions";
import { IdDefaultThreshold } from "../../constants/IdDefaultThreshold";
import { IdPersistence } from "../../constants/IdPersistence";
import { IdStyles } from "../../less/IdStyles";
import { selectNumberOfAcres } from "../../selectors/selectBaseInfo";
import { selectProductionResourceTotalBuffAmount } from "../../selectors/selectBuffsInfo";
import { selectBuildingInfoById } from "../../selectors/selectExistingBuildingInfo";
import { selectInventoryResourceInfo } from "../../selectors/selectInventoryInfo";
import { selectAllBoostRecipeInfo, selectRecipeFactorAddition, selectRecipeInfo, } from "../../selectors/selectRecipeInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { PersistenceMode } from "../../utils/PersistenceMode";
import { utilPersistence } from "../../utils/utilPersistence";
import { utilTime } from "../../utils/utilTime";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
import { ProgressWithSkip } from "../generic/progress-with-skip/ProgressWithSkip";
import { RemainingTimeDisplay } from "../generic/remaining-time-display/RemainingTimeDisplay";
import { TextLoca } from "../generic/text/TextLoca";
import { actionProductionBoost, actionProductionSkip } from "../info/production/actionProductionInfo";
import { RecipeWithAmount } from "../inventory/recipe/RecipeWithAmount";
import { ContextMenuProductStrip } from "./ContextMenuProductStrip";
import { ContextMenuResourceAmount } from "./ContextMenuResourceAmount";
var ContextMenuBuffableRunningProduction = /** @class */ (function (_super) {
    __extends(ContextMenuBuffableRunningProduction, _super);
    function ContextMenuBuffableRunningProduction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.GridColumnForProduct = 5;
        _this.GridColumnForTimeIcon = 6;
        _this.getNoProductText = function () {
            var gridPositionStyle = _this.getGridProperties(_this.GridColumnForProduct);
            return (React.createElement("div", { className: "flex flex--guts", style: gridPositionStyle },
                React.createElement(TextLoca, { id: IdLoca.humus_context_web, className: "context-menu-produce-text " + IdStyles.TextBoldPrimary })));
        };
        _this.getGridProperties = function (columnIndex) {
            return {
                gridColumnStart: columnIndex,
                gridRowStart: 1,
                msGridColumn: columnIndex,
                msGridRow: 1,
            };
        };
        _this.getZeroProductionTimeDisplay = function () {
            var gridPositionStyle = _this.getGridProperties(_this.GridColumnForTimeIcon);
            return (React.createElement("div", { style: gridPositionStyle, className: "flex flex--guts" },
                React.createElement("div", { className: "flex flex--aligned flex--centered flex--stacked" },
                    React.createElement(Icon, { icon: IdIcon.TimeIcn, styleId: IdStyles.IconExtraLarge }),
                    React.createElement("div", { className: IdStyles.TextBoldPrimary },
                        React.createElement(FontWithOutline, { style: IdStyles.TextPositive },
                            React.createElement(RemainingTimeDisplay, { seconds: 0 }))))));
        };
        _this.getProductDisplay = function (buffAmount) {
            var productionRecipe = _this.props.productionRecipe;
            var product = productionRecipe.product[0];
            var gridPositionStyle = _this.getGridProperties(_this.GridColumnForProduct);
            return (React.createElement("div", { style: gridPositionStyle, className: "flex flex--guts" },
                React.createElement("div", { className: "flex flex--aligned flex--centered flex--stacked" },
                    React.createElement(ResourceIcon, { resource: product, styleId: IdStyles.IconExtraLarge }),
                    React.createElement("div", { className: IdStyles.TextBoldPrimary },
                        React.createElement(NumberFormat, { amount: buffAmount, format: TypeNumberFormat.SignedPercent, className: IdStyles.TextBoldSecondaryOutline })))));
        };
        _this.getRecipes = function () {
            var _a = _this.props, building = _a.building, ownedBoosters = _a.ownedBoosters;
            var selectedRecipeId = _this.state.selectedRecipe
                ? _this.state.selectedRecipe.recipe.id
                : -1;
            var shouldDisplayInputIcon = selectRecipeShouldShowInputIcon(building.balancing.id);
            return _this.props.recipes.map(function (val, index) {
                var className = val.recipe.id === selectedRecipeId ? "selected" : "";
                var style = _this.getGridProperties(index + 1);
                var boosterId = val.cost[0].id;
                var boosterAmount = val.cost[0].amount;
                var ownedAmount = ownedBoosters.has(boosterId)
                    ? ownedBoosters.get(boosterId)
                    : Long.ZERO;
                return (React.createElement("div", { style: style, id: index.toString(), key: val.recipe.id },
                    React.createElement(RecipeWithAmount, __assign({}, val, { amount: boosterAmount, className: className, onClick: function () {
                            _this.onRecipeClick(val);
                            _this.registerRecipe(val);
                        }, shouldDisplayInputIcon: shouldDisplayInputIcon, ownedAmount: ownedAmount, id: boosterId }))));
            });
        };
        _this.onRecipeClick = function (recipe) {
            if (_this.isRecipeSelected(recipe)) {
                _this.setState({
                    selectedRecipe: undefined,
                });
            }
            else {
                _this.setState({
                    selectedRecipe: recipe,
                });
            }
        };
        _this.registerRecipe = function (recipe) {
            var isRecipeValid = recipe.recipe.cost !== undefined && recipe.recipe.cost[0] !== undefined;
            var isRecipeSelected = _this.isRecipeSelected(recipe);
            var boosterId = isRecipeValid && !isRecipeSelected ? recipe.recipe.cost[0].resourceId : -1;
            utilPersistence.setValue(IdPersistence.LastBooster, boosterId, PersistenceMode.Write);
        };
        _this.isRecipeSelected = function (recipe) {
            return _this.state.selectedRecipe !== undefined &&
                _this.state.selectedRecipe.recipe.id === recipe.recipe.id;
        };
        _this.getProcessTotalTime = function () {
            var building = _this.props.building;
            return building.production !== undefined &&
                building.production.recipe !== undefined &&
                building.production.recipe.productionTime !== undefined
                ? building.production.recipe.productionTime
                : 0;
        };
        _this.getProcessRemainingTime = function () {
            var building = _this.props.building;
            var remainingTimeOrZero = building.production !== undefined && building.production.production !== undefined
                ? building.production.production.remainingTime
                : 0;
            return utilTime.secondsLeftTill(remainingTimeOrZero);
        };
        return _this;
    }
    ContextMenuBuffableRunningProduction.prototype.componentDidMount = function () {
        var _a = this.props, boosterRecipe = _a.boosterRecipe, recipes = _a.recipes, selectedRecipe = _a.selectedRecipe;
        if (boosterRecipe === undefined) {
            if (selectedRecipe !== -1 && recipes !== undefined) {
                var foundRecipe = recipes.find(function (recipe) {
                    return recipe.recipe.cost !== undefined &&
                        recipe.recipe.cost[0] !== undefined &&
                        recipe.recipe.cost[0].resourceId === selectedRecipe;
                });
                if (foundRecipe !== undefined) {
                    this.setState({
                        selectedRecipe: foundRecipe,
                    });
                }
            }
        }
    };
    ContextMenuBuffableRunningProduction.prototype.render = function () {
        var _a = this.props, productionRecipe = _a.productionRecipe, building = _a.building, onBoostProduction = _a.onBoostProduction, onSkip = _a.onSkip, getProductTotalBuffAmount = _a.getProductTotalBuffAmount;
        if (!productionRecipe) {
            return React.createElement(React.Fragment, null);
        }
        var selectedRecipe = this.state.selectedRecipe;
        var recipe = this.props.boosterRecipe || this.state.selectedRecipe;
        var recipeList = this.getRecipes();
        var boosterName = recipe
            ? recipe.cost[0].locaKey
            : IdLoca.tooltip_useHumus_web;
        var processRemainingTime = this.getProcessRemainingTime();
        var product = productionRecipe.product[0];
        var id = product.id, locaKey = product.locaKey, amount = product.amount;
        var productIcon = getResourceIcon(product);
        var multiplier = selectRecipeFactorAddition(recipe);
        var roundedBuffAmount = getProductTotalBuffAmount(id, amount, multiplier);
        var iconTextComponent = (React.createElement(ContextMenuResourceAmount, { baseAmount: amount, buffAmount: roundedBuffAmount }));
        var skipProcessFactor = selectBalancingSkipProductionFactor();
        return (React.createElement("div", { className: IdStyles.ContextMenuProductionBuilding + " context-menu-fixed-container" },
            React.createElement("div", { className: IdStyles.TextButtonHeading + " flex flex--guts" },
                React.createElement(TextLoca, { id: boosterName })),
            React.createElement(ContextMenuProductStrip, { getZeroProductionTimeDisplay: this.getZeroProductionTimeDisplay, getProductDisplay: this.getProductDisplay, getNoProductText: this.getNoProductText, recipe: recipe, building: building, onBoostProduction: onBoostProduction, recipeList: recipeList, selectedRecipe: selectedRecipe !== undefined }),
            React.createElement("div", { className: "flex flex--spaced context-menu-skip-strip" },
                React.createElement(ProgressWithSkip, { duration: this.getProcessTotalTime(), fillPercentage: this.shouldFillPercentage(), onSkip: function () { return onSkip(building); }, skipProcessFactor: skipProcessFactor, remainingTime: utilTime.remainingTimeToTimestamp(processRemainingTime), icon: productIcon, tooltipLoca: locaKey, iconTextComponent: iconTextComponent }))));
    };
    ContextMenuBuffableRunningProduction.prototype.shouldFillPercentage = function () {
        var recipe = this.props.boosterRecipe || this.state.selectedRecipe;
        return recipe !== undefined && recipe.recipe.skipProduction !== undefined;
    };
    return ContextMenuBuffableRunningProduction;
}(React.Component));
var mapState = function (state) {
    var building = selectBuildingInfoById(state, state.playerBase.buildings.building.proto.id);
    var production = building !== undefined ? building.production : undefined;
    var boosterRecipe = selectRecipeInfo(state, production ? production.production.boosterId : undefined);
    var isPlayerStillInexperienced = selectNumberOfAcres(state) < IdDefaultThreshold.playerFieldsRequiredToBeExperiencedPlayer;
    var recipes = selectAllBoostRecipeInfo(state, building);
    var ownedBoosters = new Map();
    if (recipes !== undefined) {
        recipes.forEach(function (recipe) {
            recipe.cost.forEach(function (cost) {
                var longAmount = selectInventoryResourceInfo(state, cost.id).amount || Long.ZERO;
                ownedBoosters.set(cost.id, longAmount);
            });
        });
    }
    return {
        boosterRecipe: boosterRecipe,
        getProductTotalBuffAmount: function (productId, amount, multiplier) {
            return selectProductionResourceTotalBuffAmount(state, productId, amount, multiplier);
        },
        ownedBoosters: ownedBoosters,
        productionRecipe: selectRecipeInfo(state, production ? production.recipe.id : undefined),
        recipes: recipes,
        resources: state.inventoryInfo.resource,
        selectedRecipe: isPlayerStillInexperienced
            ? -1
            : utilPersistence.getValue(IdPersistence.LastBooster, -1),
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onBoostProduction: actionProductionBoost,
        onSkip: actionProductionSkip,
    }, dispatch);
};
export var ContextMenuBuffableRunningProductionDOM = connect(mapState, mapDispatch)(ContextMenuBuffableRunningProduction);



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuBuffableRunningProductionDOM.tsx
// module id = 2239
// module chunks = 3